<!-- ── Report Header ────────────────────────────────────────────────────── -->
<div class="report-header" data-cy="financial-snapshot-header">
  <div class="header-left" data-cy="financial-snapshot-header-left">
    <div class="logo-area" data-cy="financial-snapshot-logo-area">
      @if (reportLogoDocument) {
        <img class="logo-image"
          [src]="getImageUrl('LogoReport_DocumentID', reportLogoDocument) | secureImage | async"
          alt="Practice logo"
          data-cy="financial-snapshot-logo" />
      }
    </div>

    <div class="practice-info" data-cy="financial-snapshot-practice-info">
      <span class="practice-name" data-cy="financial-snapshot-practice-name">{{ProviderPracticeName}}</span>
      <span class="practice-address" data-cy="financial-snapshot-address-top">{{ProviderPracticeTopAddress}}</span>
      <span class="practice-address" data-cy="financial-snapshot-address-bottom">{{ProviderPracticeBottomAddress}}</span>

      <div class="date-info">
        <span class="date-label" data-cy="financial-snapshot-date-range-label">Date Range: {{dateRange}}</span>
        <span class="date-label" data-cy="financial-snapshot-date-range">{{initialDate | date:'longDate'}} - {{endDateLabel}}</span>
        <span class="date-label" data-cy="financial-snapshot-referring-practice">Referring Practice: {{ProviderPracticeName}}</span>
      </div>
    </div>
  </div>

  <div class="header-right" data-cy="financial-snapshot-header-right">
    <img src="assets/Images/navbar-icons/v2/new_tdo_logo.svg"
      class="tdo-logo"
      alt="TDO logo"
      data-cy="financial-snapshot-tdo-logo" />
      <span class="report-name" data-cy="financial-snapshot-report-name">{{ReportName}}</span>
      <span class="report-date" data-cy="financial-snapshot-date-today">{{DateToday}}</span>
    </div>
  </div>

  <!-- ── Report Content ──────────────────────────────────────────────────── -->
  <div class="report-content mat-elevation-z8" data-cy="financial-snapshot-content">
    @if (!isLoading) {
      <div class="main-container" data-cy="financial-snapshot-table-container">
        <table mat-table [dataSource]="dataSource" data-cy="financial-snapshot-table">
          <ng-container matColumnDef="label" sticky>
            <th mat-header-cell *matHeaderCellDef data-cy="financial-snapshot-header-label"></th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="{'myCSSclass': row.label !== 'Gross Production' && row.label !== 'Collections'}"
              data-cy="financial-snapshot-cell-label">
              {{ row.label }}
            </td>
          </ng-container>
          @for (column of financialSnapshotDataSource; track column; let i = $index) {
            <ng-container [matColumnDef]="'column' + i">
              <th mat-header-cell *matHeaderCellDef [attr.data-cy]="'financial-snapshot-header-' + i">
                {{ column.FullName }}
              </th>
              <td mat-cell *matCellDef="let row"
                (click)="openDialog(row, row['column' + i], i)"
                (keydown.enter)="openDialog(row, row['column' + i], i)"
                [attr.isCurrency]="row['column' + i]?.includes('$') ? 'true' : 'false'"
                [attr.data-cy]="'financial-snapshot-cell-' + i">
                {{ row['column' + i] }}
              </td>
            </ng-container>
          }
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{
            'myCSSclassHide': row.label === 'ID',
            'myCssGroupHeader': row.label === 'Gross Production' || row.label === 'Collections'
          }"
            data-cy="financial-snapshot-row">
          </tr>
        </table>
      </div>
    }

    @if (isLoading) {
      <div class="spinner-container" data-cy="financial-snapshot-loading">
        <mat-spinner data-cy="financial-snapshot-spinner"></mat-spinner>
        <span class="loading-text">Loading report...</span>
      </div>
    }
  </div>
